// TODO delete
// @ts-ignore
export const createLoadingSelector = actions => state => actions.some(action => state[action]);
